/**
 * "Istres & Moi" branded title — extra-bold with yellow ampersand.
 * Usage: <IstresMoiTitle className="text-[30px] text-plum-700" />
 */
export default function IstresMoiTitle({ className = "", ampClassName = "" }) {
  return (
    <span className={`font-display font-black tracking-tight ${className}`}>
      Istres <span className={`text-sun-400 ${ampClassName}`}>&amp;</span> Moi
    </span>
  );
}
